const landing = {
  initials: 'AB',

  name: {
    line1: 'ADAM',
    line2: 'BOTMA',
  },

  tagline: 'DESIGN + DEV',

  nav: [
    { label: 'Work', to: '/work' },
    { label: 'Lab', to: '/lab' },
    { label: 'Photos', to: '/photos' },
    { label: 'About', to: '/about' },
  ],

  blurb:
    'ENGINEER / DESIGNER / BUILDER\nWORKING ACROSS SOFTWARE, COMMERCE, AND DIGITAL EXPERIENCES — PLUS THE OCCASIONAL EXPERIMENT.',

  blurbMobile:
    'ENGINEER / DESIGNER / BUILDER\nWORKING ACROSS SOFTWARE, COMMERCE, AND DIGITAL EXPERIENCES — PLUS THE OCCASIONAL EXPERIMENT.',

  taglineMobile: 'Turning ideas into products, systems, and experiences.',

  para: 'Turning ideas into products, systems, and experiences. Selected work from 2018 to present, plus experiments from the Lab.',

  badge: {
    title: 'Learn about this computer',
    sub: 'click here',
    link: '/post/about-this-computer',
  },

  iframeSrc: 'https://adz.wtf/mac',
}

export default landing
